// components/chat/chat-input/SendButton.tsx
import { ArrowUp } from "lucide-react";

export const SendButton = ({ 
  disabled, 
  onClick 
}: { 
  disabled?: boolean;
  onClick?: () => void;
}) => {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className="relative mb-1 inline-flex h-fit items-center justify-center space-x-1 rounded-full bg-primary p-1.5 text-sm font-medium text-primary-foreground transition-all hover:bg-primary/90 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-primary"
      title="Send message"
      aria-label="Send message"
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
};
